export interface EnquiryView {
  id: string;
  name: string;
  phone: string;
  propertyId: string | null;
  propertyTitle: string | null;
  note: string | null;
  followUpAt: string | null;
  status: 'open' | 'visit_booked' | 'closed';
  visitId: string | null;
  createdAt: string | null;
}

/** A `datetime-local` value (`2026-10-21T10:30`, India time) as an instant the API takes, or null when empty. */
export function followUpToInstant(value: string): string | null {
  return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value) ? `${value}:00+05:30` : null;
}

/** An instant as the `datetime-local` value in India time, for editing. */
export function instantToFollowUp(iso: string | null): string {
  if (iso === null) return '';
  const ist = new Date(new Date(iso).getTime() + 330 * 60_000);
  return ist.toISOString().slice(0, 16);
}

/** True when the follow up is due now or has passed. */
export function followUpDue(iso: string | null, now: number): boolean {
  return iso !== null && new Date(iso).getTime() <= now;
}
